import axios from 'axios'
import AuthService from '../services/AuthService'

export default {
    create(data) {
        return axios.post('referrals/referrals-pool', data)
    },

    getAvailableLocations(userId, query) {
        const _fields = ['id', 'name', 'address', 'city', 'state', 'zip', 'isAvailabilitySet', 'distanceToPatient'].join(',')
        const params = {
            _fields,
            ...query,
        }
        return axios.get(`users/${userId}/matching-locations`, { params })
    },

    getAncillaryAvailableLocations(practiceId, query) {
        const _fields = ['id', 'name', 'address', 'city', 'state', 'zip', 'isAvailabilitySet', 'distanceToPatient'].join(',')
        const params = {
            _fields,
            ...query,
        }
        return axios.get(`practices/${practiceId}/matching-locations`, { params })
    },

    getReferralsPool(type, id, query) {
        const params = { ...query }
        if (AuthService.isPracticeAncillary()) {
            params[type === 'received' ? 'toPracticeId' : 'fromPracticeId'] = id
        } else {
            params[type === 'received' ? 'toUserId' : 'fromUserId'] = id
        }
        return axios.get('referrals/referrals-pool', { params })
    },

    getReferralsPoolProviders(referralPoolId) {
        const _fields = [
            'id',
            'email',
            'phone',
            'firstName',
            'lastName',
            'designation',
            'userRole(id,name)',
            'specialities(speciality(id,name),subSpeciality(id,name))',
            'professionalRating',
            'rating',
            'connectionCount',
            'referralsReceivedCount',
            'isFavorited',
            'isInMyNetwork',
            'isSignupFinished',
            'practice(id,name,practiceType,locations(id,name,address,city,state,zip,latitude,longitude))',
            'avatar(thumb-360,source)',
            'physicianGroup(id,name)',
            'name',
            'image',
        ].join(',')

        return axios.get(`referrals/referrals-pool/${referralPoolId}/providers-list`, { params: { _fields } })
    },

    getReferralPoolById(id, type, activeUserId) {
        const params = { type, activeUserId }
        return axios.get(`referrals/referrals-pool/${id}`, { params })
    },

    sendProposeTimeSlots(referralPoolId, data) {
        return axios.put(`/referrals/referrals-pool/${referralPoolId}/propose-time-slots`, data)
    },
}
